module.exports = __webpack_public_path__ + "img/infografika.5ce738c1.png";